export default {
  aSelect: () =>
    import ('./sky-select.vue'),
  aDepartSelect: () =>
    import ('./sky-depart-select.vue'),
  aDepartCascader: () =>
    import ('./sky-depart-cascader.vue'),
  aCascader: () =>
    import ('./sky-cascader.vue'),
  aDatePicker: () =>
    import ('./sky-date-picker.vue'),
  aInput: () =>
    import ('./sky-input.vue'),
  aCheckbox: () =>
    import ('./sky-checkbox.vue'),
  aRadio: () =>
    import ('./sky-radio.vue'),
  aTextarea: () =>
    import ('./sky-textarea.vue'),
  aSwitch: () =>
    import ('./sky-switch'),
  aInputNumber: () =>
    import ('./sky-input-number'),
  aSpan: () =>
    import ('./sky-span'),
  aAutoSearch: () =>
    import ('./sky-auto-search'),
  aProvince: () =>
    import ('./sky-province'),
  aGetNumber: () =>
    import ('./sky-get-number'),
  aPostSelect: () =>
    import ('./sky-post-select'),
  aTimePicker: () =>
    import ('./sky-time-picker'),
  aTimeSelect: () =>
    import ('./sky-time-select'),
  aInputSlot: () =>
    import ('./sky-input-slot'),
  aInputSelect: () =>
    import ('./sky-input-select'),
  aRichText: () =>
    import ('./sky-rich-text'),
  aOrganizationCascader: () =>
    import ('./sky-organization-cascader'),
  aSkyUpload: () =>
    import ('./sky-upload'),
  aReceive: () =>
    import ('./sky-receive.vue'),
}



// WEBPACK FOOTER //
// ./src/components/formComponents/index.js